<template>
  <div class="sm-facet_common" :class="getCssContainer">
    <div class="sm-facet__header">
      <div class="sm-facet__title"><span
          class="sm-facet__title__name">{{ title }}</span>
      </div>
      <button v-if="hasQueryFilter()" @click.stop="clearQueryFilter()" type="button" class="sm-facet__clear">
        Очистить
      </button>
    </div>

    <div class="sm-facet__filter" v-if="items.length > 8">
      <div class="sm-facet__wrap">
        <input
            type="text"
            placeholder="Поиск"
            class="sm-facet__input"
            v-model="prop_filter[facetname]"
            @keyup="filterTags(facetname)"
        >
        <svg svg="" width="12" height="12" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="sm-facet__icon">
          <use xlink:href="#magnifier-facet"></use>
        </svg>
      </div>
    </div>

    <ul class="sm-facet-options" :class="{'sm-facet-options_scrollable': items.length > 10}">
      <li v-for="item in filtered_tags" class="sm-facet-options__item" :key="slugify(facetname + '_' + item.name)">
        <label class="sm-facet-option" :class="{'sm-facet-option_disabled': isEnabled(item)}">
          <input
              class="sm-facet-option__checkbox"
              type="checkbox"
              :id="slugify(facetname + '_' + item.name)"
              :value="item.name"
              :disabled="isEnabled(item)"
              v-model="checkedItems"
              @change="applyUrlFilter(queryparam, item.name, $event)"
          >
          <span class="sm-facet-option__checkmark"></span>

          <span v-if="type==='color'" class="sm-facet-option__color" :style="{backgroundColor: item.name}"></span>
          <span v-else class="sm-facet-option__text"><b></b>{{ item.name }}</span>

          <span v-show="isShowValue" class="sm-facet-option__amount">{{ item.value }}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import CyrillicToTranslit from "cyrillic-to-translit-js";
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "facet-common",
  props: [
    "title",
    "items",
    "facetname",
    "queryparam",
    "active",
    "type" // common|yesnow|color
  ],
  data: function () {
    return {
      prop_filter: [],
      itemsProxy: [],
      slugProxy: []
    };
  },
  computed: {
    ...mapGetters("search", ["selectedFacets", "queryFilters", "isMobile", "currentOpenFacet"]),
    filtered_tags: function() {
      if(this.itemsProxy.length === 0) {
        //this.itemsProxy = JSON.parse(JSON.stringify(this.items));
        this.itemsProxy = this.items;
      }
      return this.itemsProxy;
    },
    isActive: function () {
      return (this.items.length > 0 && this.active);
    },
    isShowValue: function () {
      return (this.type !== "color");
    },
    getCssContainer: function () {
      return (this.type !== "color") ? "" : "facet-color";
    },
    checkedItems: {
      get: function () {
        return (this.type==="yesnow") ? this.getChecked(this.facetname) : this.getCheckedArr(this.facetname);
      },
      set: function (value) {}
    },
  },
  watch: {
    items: function () {
      // чтобы обновились filtered_tags
      this.itemsProxy = [];
    }
  },
  methods: {
    ...mapActions("search", ["addFilter", "removeFilter", "removeFilters", "doSearch"]),
    hasQueryFilter: function () {
      const queryparam = this.queryparam;
      const f = this.queryFilters.filter(function (value) {
        return typeof value[queryparam] !== 'undefined';
      });
      return Boolean(f.length);
    },
    clearQueryFilter: function () {
      this.removeFilters(this.queryparam);
      this.doSearch().then(() => {}).catch(err => { console.log(err) });
      this.checkedItems = [];
    },
    applyUrlFilter: function (name, value, e) {
      if(e.target.checked) {
        this.addFilter({[name]:value});
      } else {
        this.removeFilter({[name]:value});
      }
      this.doSearch().then(() => {}).catch(err => { console.log(err) });
    },
    getCheckedArr(name) {
      let facet = this.selectedFacets.filter(function (item) {
        return item.name === name;
      });
      return (facet.length) ? facet[0].value : [];
    },
    getChecked(name) {
      let facet = this.selectedFacets.filter(function (item) {
        return item.name === name;
      });
      return (facet.length) ? facet[0].value[0]==='да' : false;
    },
    filterTags: function (name) {
      //let items = JSON.parse(JSON.stringify(this.items));
      let items = this.items;
      let pf = this.prop_filter[name];
      if(pf !== '') {
        items = items.filter(function (item) {
          return item.name.toLowerCase().indexOf(pf.toLowerCase()) !== -1
        });
      }

      this.itemsProxy = items;
    },
    slugify: function (s) {
      if(typeof this.slugProxy[s] !== 'undefined') {
        return this.slugProxy[s];
      }

      if (typeof s === 'string' || s instanceof String) {
        const cyrillicToTranslit = new CyrillicToTranslit();
        this.slugProxy[s] = cyrillicToTranslit.transform(s, '_').toLowerCase();
        return this.slugProxy[s];
      }
      return s;
    },
    isEnabled: function(item) {
      return typeof item.enabled !== 'undefined' && !item.enabled;
    },
  }
}
</script>